import { getAllPanelCandidate } from "../../utils/apiFunctions.js";
import toast from "../../components/mixin/toast.js";

const mobilePanelMixins = {
  mixins: [toast],
  methods: {
    async getAllPanelCandidate(data) {
      if (this.$route.name !== "mobpanelDetails") {
        this.LoaderStatus = true;
      }
      this.showLoader = true;
      if (this.mainPage && !this.schedulePage && !this.feedbackPage) {
        this.pageCount = 1;
      } else {
        this.pageCount = 10;
      }
      this.payload = {
        page: this.currentPage - 1,
        count: this.pageCount,
        sortBy: {
          column: this.statusValue,
          order: this.sortOrder,
        },

        filters: {
          feedback: data,
          jobName: this.filter.jobName,
          // ...this(this.filter.jobName != "" && {jobName : this.filter.jobName}),
          skills: this.filter.skills,
          // ...(this.filter.skills.length != 0 && {skills : this.filter.skills}),
          ...(this.filter.round.length != 0 && { round: this.filter.round }),
          // round : this.filter.round
        },
        searchQuery: this.searchname,
      };
      const res = await getAllPanelCandidate(this.payload);
      if (res.status == 200) {
        this.showLoader = false;

        if (this.filtercount == 0) {
          this.interviewRounds = res.data.data.rounds.map((round) => {
            if (round === "F") {
              return { text: "Final", value: round };
            }
            return { text: `Round ${round}`, value: round };
          });
        }

        if (this.currentPage == 1) {
          this.allpaneldata = res.data.data.data;
        } else {
          this.allpaneldata = [...this.allpaneldata, ...res.data.data.data];
        }
        if (data == "false") {
          this.schedulePage = true;
          this.totalScheduledInterviews = res.data.data.total;
          this.pageEnd = res.data.data.pageEnd;
        } else {
          this.totalFeedbackProvided = res.data.data.total;
          this.pageEnd = res.data.data.pageEnd;
        }
      }
      this.LoaderStatus = false;
    },
    resetPagination() {
      this.currentPage = 1;

      this.allpaneldata = [];
      this.showLoader = false;
      if (this.$route.query.status == "feedbacktab") {
        this.getAllPanelCandidate("true");
      } else if (this.$route.query.status == "scheduletab") {
        this.getAllPanelCandidate("false");
      }
    },
    searchPanel() {
      if (this.$route.query.status == "feedbacktab") {
        this.currentPage = 1;
        clearTimeout(this.timer);
        this.getAllPanelCandidate("true");
      } else if (this.$route.query.status == "scheduletab") {
        this.currentPage = 1;
        clearTimeout(this.timer);
        this.getAllPanelCandidate("false");
      }
    },
    onScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        // Check if there is more data to load.
        if (this.$route.query.status == "scheduletab") {
          if (
            this.checkbetween(this.pageEnd, 0, this.totalScheduledInterviews) &&
            !this.showLoader
          ) {
            this.showLoader = true;
            this.currentPage++;
            this.getAllPanelCandidate("false");
          }
        } else if (this.$route.query.status == "feedbacktab") {
          if (
            this.checkbetween(this.pageEnd, 0, this.totalFeedbackProvided) &&
            !this.showLoader
          ) {
            this.showLoader = true;

            this.currentPage++;
            this.getAllPanelCandidate("true");
          }
        }
      }
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
  },
};
export default mobilePanelMixins;
